/**
 * Created by Jan on 16.07.2017.
 */

(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Forms = Lfl.Forms || {};

    (function (Forms, $, undefined) {
        /**
         * @memberOf Lfl.Forms
         */
        Lfl.Forms.Inputs = Forms.Inputs || {};

        (function (Inputs, $, undefined) {
            if (Lfl.Files.isLoadedAlready(Lfl.Forms.Inputs, 'Datepicker')) {
                return;
            }

            /*
             |==========================================================================================================
             | Documentation
             |==========================================================================================================
             */

            /**
             * Helps turn inputs into JS enhanced datepickers.
             *
             * Currently we are using the bootstrap datepicker by Uxsolutions:
             *   https://github.com/uxsolutions/bootstrap-datepicker
             *   ! Not to be confused with the other bootstrap datepicker by eonasdan.
             *
             * @memberOf Lfl.Forms.Inputs
             */
            Lfl.Forms.Inputs.Datepicker = Inputs.Datepicker || {};

            (function (Datepicker, $, undefined) {
                // TODO MOBA II - merge with _date-form-field.blade.php
                // - Problem: how to share defaults between js and php?
                //  - Probably just have a nice array with defaults for both and have a comment asking to keep them in
                //    sync.
                /*
                 |======================================================================================================
                 | Object definition
                 |======================================================================================================
                 */

                var DEFAULT_DATEPICKER_OPTIONS = {
                    format: 'd. m. yyyy', // Cannot use Lfl.Datetime.USER_PRESENTED_DATE_FORMAT_DATEPICKER. See Todo SyncConstants
                    language: Lfl.Lang.getLocale(),
                    // If multidate, then:
                    multidateSeparator: ", ",
                    disableTouchKeyboard: true

                    // We do not change the default orientation - the client code should define it if needed and as a
                    // default the "auto" is actually much safer.
                    
                    // We do not define the default container, neither do we attempt to compute it implicitly. The
                    // client code has to know the context, where datepicker is rendered. This may be improved once we
                    // correctly implement the Scrolling Manager, which will enable us to get the first scrolling
                    // container of given element - if any exists, <body> otherwise.
                    // Update: we now provide a way of letting the client code say "use the most obvious container" in
                    // the determineDefaultContainer method below.
                    // For further work on this, see DetermineNearestScrollingContainer
                };

                var DEFAULT_LFL_OPTIONS = {
                    toggleButton: {
                        enabled: false
                    }
                };

                // Notice: the icon is hardcoded in places where the calendar is used.
                // If you change the icon here, change the other usages as well.
                var OPEN_ICON = 'today';
                var CLOSE_ICON = 'remove';

                /*
                 |------------------------------------------------------------------------------------------------------
                 | Public methods
                 |------------------------------------------------------------------------------------------------------
                 */


                /**
                 * Initializes the datepicker for given $element according to optional lflParams while passing in
                 * provided datepicker parameters.
                 *
                 * @param {{}} parameters
                 * @param {jQuery} parameters.$element The element on which the datepicker should be initialized.
                 * Typically a text input, but may be a wrapper around the element. See datepicker documentation.
                 * @param {{}} [parameters.datepickerOptions] A list of options for the datepicker. Default ones are
                 * used and merged with the provided parameters.
                 * @param {{}} [parameters.lflOptions] Options that define additional behaviour of this method.
                 * @param {{}} [parameters.lflOptions.toggleButton] Options for the button which toggles show/hide on
                 * the picker. Does not have to be defined.
                 * @param {boolean} [parameters.lflOptions.toggleButton.enabled]
                 * @param {boolean} [parameters.lflOptions.toggleButton.$button]
                 *
                 * @memberOf Lfl.Forms.Inputs.Datepicker
                 */
                Datepicker.initPicker = function (parameters) {
                    var datepickerOptions = $.extend({}, DEFAULT_DATEPICKER_OPTIONS, parameters.datepickerOptions);
                    var lflOptions = $.extend({}, DEFAULT_LFL_OPTIONS, parameters.lflOptions);

                    var picker = parameters.$element.datepicker(
                        datepickerOptions
                    );

                    if (datepickerOptions.disableTouchKeyboard === true) {
                        disableTouchKeyboard(picker);
                    }

                    if (lflOptions.toggleButton.enabled === true) {
                        enableToggleButton(lflOptions.toggleButton, picker);
                    }

                    /* Handle range datepicker issue - dropdown overflowing from viewport */
                    if (picker.hasClass('input-daterange')) {
                        picker.on('show', function (e) {
                            if (e.target.id === 'date_range_from') {
                                const $rightDatepicker = $('.datepicker-dropdown');

                                $rightDatepicker.removeClass('datepicker-orient-right');
                                $rightDatepicker.addClass('datepicker-orient-left');
                                $rightDatepicker.css('left', e.target.getBoundingClientRect().x);
                            }
                        });
                    }

                    return picker;
                };

                /**
                 * Since disable touch keyboard is not working properly natively, we have to modify it's behaviour.
                 *
                 * The datepicker option itself correctly prevents the display of keyboard after a date is picked, but
                 * on certain devices it does not prevent the displaying of the keyboard when the input is clicked.
                 *
                 * @param {*} picker The datepicker.
                 */
                function disableTouchKeyboard(picker) {
                    var isDatepickerVisible = false;

                    picker.on('show', function (e) {
                        /**
                         * Hack to disable touch keyboard with blur() method,
                         * but only if the datepicker is not visible (to minimize accessibility problems)
                         * so with a second click, the keyboard appears.
                         */
                        if ((window.navigator.msMaxTouchPoints || 'ontouchstart' in document)) {
                            if (!isDatepickerVisible) {
                                $('input', $(this))[0].blur();
                            }
                        }
                        isDatepickerVisible = true;

                    }).on('hide', function (e) {
                        isDatepickerVisible = false;
                    });
                }

                /**
                 *
                 * @param {{}} options
                 * @param {*} picker The datepicker instance
                 * @param {{jQuery}} options.$button
                 */
                function enableToggleButton(options, picker) {
                    var $toggleButton = options.$button;
                    var $toggleIcon = $toggleButton.find('i');

                    picker.on("show", function (e) {
                        // TODO IconSwapper
                        $toggleIcon.removeClass(OPEN_ICON);
                        $toggleIcon.addClass(CLOSE_ICON);

                        $toggleButton.on('click.lfl-datepicker-toggle', function (e) {
                            picker.datepicker('hide');
                        });
                    }).on("hide", function (e) {
                        $toggleIcon.removeClass(CLOSE_ICON);
                        $toggleIcon.addClass(OPEN_ICON);

                        $toggleButton.off('click.lfl-datepicker-toggle');
                    });
                }
            }(Inputs.Datepicker, jQuery));
        }(Forms.Inputs, jQuery));
    }(Lfl.Forms, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
